module.exports = __webpack_public_path__ + "img/Elgedees.65b39d96.png";